// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"ca3c1d24","82":"3e12c142","238":"6946a34c","273":"af156702","294":"653ad9f8","391":"908b7e6a","469":"bb4be7b3","514":"b3be4450","556":"9d340efb","573":"456eb6b7","606":"23dea47b","950":"7a9905e4"}[chunkId] + ".chunk.js";
};